module.exports = __webpack_public_path__ + "static/media/ph.hero.projects.7a06ee75.jpg";